import { render, staticRenderFns } from "./SupervisorMenu.vue?vue&type=template&id=5011aebd&scoped=true"
import script from "./SupervisorMenu.vue?vue&type=script&lang=ts"
export * from "./SupervisorMenu.vue?vue&type=script&lang=ts"
import style0 from "./SupervisorMenu.vue?vue&type=style&index=0&id=5011aebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5011aebd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VContainer,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle})
